'use client'

import Image from '@/components/Image'
import { useLanguage } from '@/i18n/LanguageProvider'
import {
  PATHIN_CONTACT_EMAIL,
  PATHIN_SOCIAL_URLS,
} from '@/config/pathinContact'

type Props = {
  className?: string
  linkClassName?: string
  iconClassName?: string
}

export default function PathinSocialIcons({
  className = 'flex flex-row items-center gap-6',
  linkClassName = 'text-[#B9AE9A] hover:text-white transition-colors',
  iconClassName = 'w-6 h-6',
}: Props) {
  const { t } = useLanguage()
  const xhsLabel = t('contact.social.xiaohongshu')
  const igLabel = t('contact.social.instagram')

  return (
    <div className={className}>
      <a
        href={`mailto:${PATHIN_CONTACT_EMAIL}`}
        className={linkClassName}
        aria-label="Email"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className={iconClassName} fill="currentColor" viewBox="0 0 256 256">
          <path d="M104,152a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H96A8,8,0,0,1,104,152Zm136-36v60a16,16,0,0,1-16,16H136v32a8,8,0,0,1-16,0V192H32a16,16,0,0,1-16-16V116A60.07,60.07,0,0,1,76,56h76V24a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H168V56h12A60.07,60.07,0,0,1,240,116ZM120,176V116a44,44,0,0,0-88,0v60Zm104-60a44.05,44.05,0,0,0-44-44H168v72a8,8,0,0,1-16,0V72H116.75A59.86,59.86,0,0,1,136,116v60h88Z" />
        </svg>
      </a>
      <a
        href={PATHIN_SOCIAL_URLS.xiaohongshu}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClassName}
        aria-label={xhsLabel}
      >
        <Image src="/icon/rednote.svg" alt={xhsLabel} width={24} height={24} className={iconClassName} />
      </a>
      <a
        href={PATHIN_SOCIAL_URLS.instagram}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClassName}
        aria-label={igLabel}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className={iconClassName} fill="currentColor" viewBox="0 0 256 256">
          <path d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160ZM176,24H80A56.06,56.06,0,0,0,24,80v96a56.06,56.06,0,0,0,56,56h96a56.06,56.06,0,0,0,56-56V80A56.06,56.06,0,0,0,176,24Zm40,152a40,40,0,0,1-40,40H80a40,40,0,0,1-40-40V80A40,40,0,0,1,80,40h96a40,40,0,0,1,40,40ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z" />
        </svg>
      </a>
    </div>
  )
}
